
// Utility functions for cost visualization components

export const createParticles = (particlesRef: React.RefObject<HTMLDivElement>, isMobile: boolean) => {
  const particles = particlesRef.current;
  if (!particles) return;
  
  const particleCount = isMobile ? 25 : 40;
  
  // Clear existing particles
  particles.innerHTML = '';
  
  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    particle.className = 'particle';
    
    // Random position
    const x = Math.random() * (isMobile ? window.innerWidth : particles.offsetWidth);
    const y = Math.random() * (isMobile ? window.innerHeight : particles.offsetHeight);
    
    // Random size
    const size = 2 + Math.random() * 3;
    
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.opacity = (0.3 + Math.random() * 0.5).toString();
    
    // Store animation properties
    particle.dataset.vx = (-0.3 + Math.random() * 0.6).toString();
    particle.dataset.vy = (-0.3 + Math.random() * 0.6).toString();
    
    particles.appendChild(particle);
  }
};

export const animateParticles = (
  particlesRef: React.RefObject<HTMLDivElement>, 
  isMobile: boolean,
  animationFrameRef: React.MutableRefObject<number | undefined>
) => {
  if (!particlesRef.current) return;
  
  const allParticles = particlesRef.current.querySelectorAll('.particle');
  const containerWidth = isMobile ? window.innerWidth : particlesRef.current.offsetWidth;
  const containerHeight = isMobile ? window.innerHeight : particlesRef.current.offsetHeight;
  
  allParticles.forEach(p => {
    const element = p as HTMLElement;
    let x = parseFloat(element.style.left);
    let y = parseFloat(element.style.top);
    
    const vx = parseFloat(p.getAttribute('data-vx') || '0');
    const vy = parseFloat(p.getAttribute('data-vy') || '0');
    
    x += vx;
    y += vy;
    
    // Wrap around screen
    if (x < 0) x = containerWidth;
    if (x > containerWidth) x = 0;
    if (y < 0) y = containerHeight;
    if (y > containerHeight) y = 0;
    
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;
  });
  
  animationFrameRef.current = requestAnimationFrame(() => 
    animateParticles(particlesRef, isMobile, animationFrameRef)
  );
};

export const animateDesktopCostBars = (containerRef: React.RefObject<HTMLDivElement>) => {
  const traditionalBar = containerRef.current?.querySelector('#traditional-bar') as HTMLElement | null;
  const mungerBar = containerRef.current?.querySelector('#munger-bar') as HTMLElement | null;
  
  setTimeout(() => {
    if (traditionalBar) traditionalBar.style.height = '90%';
    if (mungerBar) mungerBar.style.height = '8%';
  }, 500);
};
